import { gql } from '@apollo/client'

export class RawUnitQueryBuilder {
    constructor(unitQuery) {
        this.unitQuery = unitQuery;
    }

    build(context) {
        return this.unitQuery;
    }

    toString() {
        return this.unitQuery;
    }

    getQueryString() {
        const unitName = this.getQueryName();
        const opName = unitName.substring(0, 1).toUpperCase() + unitName.substring(1);
        const variablesDef = 'id: String!';
        const queryString = `query ${opName}(${variablesDef}) {\n${this.toString()}\n}`;
        return queryString;
    }

    getQueryName() {
        const text = (this.unitQuery || '').trim();
        if (!text) return '';

        const endIdxParen = text.indexOf('(');
        const endIdxBrace = text.indexOf('{');
        let endIdx = -1;
        if (endIdxParen === -1) {
            endIdx = endIdxBrace;
        } else if (endIdxBrace === -1) {
            endIdx = endIdxParen;
        } else {
            endIdx = Math.min(endIdxParen, endIdxBrace);
        }
        const head = endIdx > 0 ? text.substring(0, endIdx) : text;
        const tokens = head.trim().split(/\s+/);
        return tokens.length ? tokens[tokens.length - 1] : '';
    }

    getGql() {
        return gql`${this.getQueryString()}`;
    }
}
